import React from 'react'
import PropTypes from 'prop-types'

import { StyledProgessBar } from './StyledLoading'

const ProgressBar = ({ progress }) => (
	<StyledProgessBar>
		<span style={{ width: `${progress > 100 ? 100 : progress}%` }}><span /></span>
	</StyledProgessBar>
)

ProgressBar.propTypes = {
	progress: PropTypes.number.isRequired // Progress in %
}

export default ProgressBar
